import dayjs from 'dayjs';
import NoIconImage from '../assets/placeholder-image-small.png?inline';
import store, { dispatch } from '../redux/store';
import { AddCartItem, CartOperationType } from '../types/cart';
import { EquipmenId, PriceEntry, PriceStatus } from '../types/equipment';
import { messageContents } from '../constants/message';
import { openCartModal } from '../redux/slice/cartSlice';
import { openMessageModal } from './message';
import { priceValidityInSeconds } from '../constants/equipment';

export const queryEquipmentDetails = (equipmentId: EquipmenId) => {
  const imageElement = document.querySelector(`[data-primary-image-for="${equipmentId}"]`);
  const nameElement = document.querySelector(`[data-equipment-name-for="${equipmentId}"]`);
  const slugElement = document.querySelector(`[data-slug-for="${equipmentId}"]`) as HTMLElement;

  const name = nameElement?.textContent?.trim();
  const slug = slugElement?.getAttribute(`data-slug-value`);
  let imageSource = imageElement?.getAttribute('src');

  if (!imageSource) {
    imageSource = NoIconImage;
  }

  return { name, imageSource, slug };
};

export const addToCartUtlityFn = (equipmentId: EquipmenId, quantity: number) => {
  const branchId = store.getState().location.branch?.branch_id;
  const priceCatalogKey = getPriceCatalogKey(equipmentId);
  const priceEntry = store.getState().prices.priceCatalog[priceCatalogKey];

  if (branchId && priceEntry && !priceEntry.price && !isPriceInLoadingStage(priceEntry.status)) {
    openMessageModal(messageContents.missingEquipmentPrice);
    return;
  }

  const { name, imageSource, slug } = queryEquipmentDetails(equipmentId);
  if (!name || !imageSource || !slug) {
    console.log('Error: missing equipment data');
    return;
  }
  const cartItem: AddCartItem = {
    equipmentId,
    name,
    imageSource,
    slug,
    quantity,
  };
  dispatch(
    openCartModal({
      cartOperationType: CartOperationType.ADD,
      cartItem,
      toggleCartHeaderOnUpdate: true,
    }),
  );
};

export const isPriceInitialized = (status: PriceStatus) => {
  return status !== PriceStatus.INIT && status !== PriceStatus.LOADING;
};

export const isPriceInLoadingStage = (status: PriceStatus) => {
  return status === PriceStatus.INIT || status === PriceStatus.LOADING;
};

export const getPriceCatalogKey = (equipmentId: EquipmenId) => {
  // If equipment id is a string, srip all double quote characters before parsing as a number
  return typeof equipmentId === 'string' ? parseInt(equipmentId.replaceAll('"', '')) : equipmentId;
};

export const getPriceCacheKey = (
  equipmentId: EquipmenId,
  branchId: string | number | null = null,
  companyId: string | number | null = null,
  locationId: string | number | null = null,
) => {
  if (branchId) {
    return `BRANCH_${branchId}_${equipmentId}`;
  } else if (companyId) {
    return `COMPANY_${companyId}_${equipmentId}`;
  } else if (locationId) {
    return `LOCATION_${locationId}_${equipmentId}`;
  }
};

export const isPriceValid = (item: PriceEntry) => {
  const isExpired = dayjs().unix() - item.dateTimeStamp > priceValidityInSeconds;
  const isNotValid =
    item.status !== PriceStatus.LOADING &&
    item.status !== PriceStatus.COMPLETED &&
    item.status !== PriceStatus.PRICE_NOT_FOUND;
  return !isExpired && !isNotValid;
};
